import { ClientNuxtExperimentRelay, ServerNuxtExperimentRelay } from '@tidal/experiment-relay';
export default (async function ({ $config, $cookieConsent, $cookies, $sentry, req, res }, inject) {
    const moduleOptions = $config.experimentRelay;
    if (!moduleOptions) {
        throw new Error('[@tidal/experiment-relay] Missing "experiment-relay" configuration. Can not initialize plugin.');
    }
    if (!moduleOptions.enable) {
        return;
    }
    const experimentRelay = process.client ? new ClientNuxtExperimentRelay({ $cookieConsent, $cookies, $sentry, moduleOptions }) : new ServerNuxtExperimentRelay({ $sentry, moduleOptions, req, res });
    $cookieConsent.onConsentChanged(() => {
        if (!$cookieConsent.isCookieAllowed('performance')) {
            experimentRelay?.removeExperimentationID();
        }
    });
    inject('experimentRelay', experimentRelay);
});
